import { render, staticRenderFns } from "./1.vue?vue&type=template&id=f66209be&scoped=true&"
var script = {}
import style0 from "./1.vue?vue&type=style&index=0&id=f66209be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66209be",
  null
  
)

export default component.exports